import { Share2, Users } from 'lucide-react';
import { useId } from 'react';

interface FolderIconProps {
  /** Width in pixels; the height follows the folder's shape. */
  size: number;
  /** A sign pressed into the front: a team's own folder, or one another team shared. */
  emblem?: 'team' | 'shared';
}

/** A folder: a back with a tab, a sheet of paper showing over its edge, and a front, in Finder's graphite. */
const FolderIcon = ({ size, emblem }: FolderIconProps) => {
  // Every folder on the page carries its own gradient, and an id has to be unique in the document.
  const gradientId = useId();
  const Emblem = emblem === 'team' ? Users : Share2;
  // A small folder, as in the list, draws its sign larger and bolder about the same centre: at
  // the size an icon has, the sign would be a few pixels of hairline.
  const isSmall = size < 48;

  return (
    <svg
      width={size}
      height={size * 0.8}
      viewBox="0 0 120 96"
      aria-hidden
      style={{ flexShrink: 0, filter: 'drop-shadow(0 1px 1.5px rgba(0, 0, 0, 0.35))' }}
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#C2C5CA" />
          <stop offset="1" stopColor="#9EA2A8" />
        </linearGradient>
      </defs>
      <path
        d="M4 14a8 8 0 0 1 8-8h27.5a8 8 0 0 1 5.9 2.6L51 15h57a8 8 0 0 1 8 8v61a8 8 0 0 1-8 8H12a8 8 0 0 1-8-8z"
        fill="#8C9096"
      />
      <rect x="10" y="20" width="100" height="40" rx="3" fill="#F2F3F5" />
      <path
        d="M4 32a6 6 0 0 1 6-6h100a6 6 0 0 1 6 6v52a8 8 0 0 1-8 8H12a8 8 0 0 1-8-8z"
        fill={`url(#${gradientId})`}
      />
      <path d="M10 26.5h100" stroke="#D3D6DA" strokeWidth="1" />
      {emblem && (isSmall
        ? <Emblem x={37} y={36} size={46} color="#6A6E74" strokeWidth={3} />
        : <Emblem x={44} y={43} size={32} color="#6A6E74" strokeWidth={2.25} />)}
    </svg>
  );
};

export default FolderIcon;
